import { Injectable } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { Subject, Observable } from "rxjs";
import { AlertIndicator } from "../models/AlertIndicator";

@Injectable()
export class IndicatorsService {
  private alert;
  private alert$ = new Subject<AlertIndicator>();
  private loadingInterstitial: boolean;
  private loadingInterstitial$ = new Subject<any>();

  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.updateLoadingInterstitial();

        this.updateAlert();
      }
    });
  }

  showInterstitial() {
    this.loadingInterstitial = true;
    this.updateLoadingInterstitial();
  }

  hideInterstitial() {
    this.loadingInterstitial = false;
    this.updateLoadingInterstitial();
  }

  alertSuccess(message: string) {
    this.alert = { type: "success", text: message };
    this.updateAlert();
  }

  alertError(message: string) {
    this.alert = { type: "error", text: message };
    this.updateAlert();
  }

  updateAlert() {
    this.alert$.next(this.alert);
  }

  getAlert(): Observable<AlertIndicator> {
    return this.alert$.asObservable();
  }

  updateLoadingInterstitial() {
    this.loadingInterstitial$.next(this.loadingInterstitial);
  }

  getLoadingInterstitial(): Observable<boolean> {
    return this.loadingInterstitial$.asObservable();
  }
}
